import { useEffect, useState } from "react";

import { shallowEqual, useDispatch, useSelector } from "react-redux";

import * as actions from "@/redux/actions";
import RightSideBar from "@widgets/RightSideBar/RightSideBar";
import SntOnOffSwitch from "@/cleanup/wrappers/Switch/SntOnOffSwitch";
import { AssetTag, SuccessTag } from "@cleanup/components/TagMore";
import { SensolusDatetimeReact } from "@/constants/Config";
import SntLocationStopIcon from "@icons/SntLocationStopIcon";
import notificationClient from "@/apis/notificationClient";
import moment from "@/constants/SensolusMoment";
import SntDialog from "@/components/SntDialog/SntDialog";
import { Form } from "react-bootstrap";
import SntLink from "@/components/ReactBootstrap/SntLink";
import SntMarkdown from "@/cleanup/widgets/markdown/SntMarkdown";

const NotificationSidebar = () => {
  const { showNotification, notifications } = useSelector(
    (state) => state.all,
    shallowEqual
  );

  const loginInfo = useSelector((state) => state.user);
  const language = useSelector((state) => state.language);

  const dispatch = useDispatch();

  const [checked, setChecked] = useState(false);
  const [directNotification, setDirectNotification] = useState([]);

  useEffect(() => {
    getMessages();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const getMessages = () => {
    // if (!loginInfo.hideNotifications) {
    let fromDate = moment().subtract(90, "days").startOf("day");
    notificationClient
      .getFromDate(fromDate.format())
      .then(({ data }) => {
        let newMessages = data.filter((item) => !item.hasRead);
        dispatch(actions.setGlobalNotification(data));
        dispatch(actions.setGlobalNotificationCount(newMessages.length));
        // Only show popup notifications for normal users
        const isNormalUser = loginInfo.userType === "NORMAL";
        setDirectNotification(
          isNormalUser
            ? data.filter((item) => item.showAsPopup && !item.hasRead)
            : []
        );
      })
      .catch((error) => {});
    // }
  };

  const onClose = (ids) => {
    notificationClient
      .makeAsRead(ids)
      .then(({ data }) => {
        let newData = notifications.map((item) => ({ ...item, hasRead: true }));
        dispatch(actions.setGlobalNotification(newData));
        dispatch(actions.setGlobalNotificationCount(0));
        setDirectNotification([]);
      })
      .catch((error) => {});
  };

  return (
    <>
      <SntDialog
        isShow={directNotification.length}
        isShowSaveButton={false}
        title={language.notifications_key}
        onClose={() => onClose(directNotification.map((item) => item.id))}
      >
        {() => (
          <>
            {directNotification.map((item, key) => {
              return (
                <NotificationItem
                  key={key}
                  item={item}
                  language={loginInfo.language}
                  contentClass="notification-message-container-popup"
                />
              );
            })}
          </>
        )}
      </SntDialog>
      {showNotification && (
        <RightSideBar
          onClose={() => {
            onClose(notifications.map((item) => item.id));
            dispatch(actions.setShowGlobalNotification(false));
          }}
          loading={false}
          title={language.notifications_key}
        >
          {loginInfo.hideNotifications ? (
            <>{language.notification_sidebar_hide_info_key}</>
          ) : (
            <>
              <div className="d-flex align-items-center mb-3">
                <div className="me-4">{language.only_show_unread_key}</div>
                <div>
                  <SntOnOffSwitch checked={checked} onChange={setChecked} />
                </div>
              </div>
              {notifications
                .filter((item) => {
                  if (checked === true) {
                    return !item.hasRead;
                  }
                  return true;
                })
                .map((item, key) => {
                  return (
                    <NotificationItem
                      key={key}
                      item={item}
                      language={loginInfo.language}
                      contentClass="notification-message-container"
                    />
                  );
                })}
              <div className="text-center">
                <SntLocationStopIcon size={36} className="mb-3" />
                <div className="mb-3">
                  {language.notification_sidebar_info_key}
                </div>
                <div>
                  <SntLink to="/profile">
                    {language.notification_sidebar_info2_key}
                  </SntLink>
                </div>
              </div>
            </>
          )}
        </RightSideBar>
      )}
    </>
  );
};

export default NotificationSidebar;

const NotificationItem = ({ item, language, contentClass }) => {
  let content =
    item.contentByLanguage[language] || item.contentByLanguage["en"];
  let title = item.titlesByLanguage[language] || item.titlesByLanguage["en"];
  return (
    <div>
      <h5 className="mb-1">
        <span className="mb-1">{title}</span>
        {!item.hasRead && (
          <SuccessTag tagName={"New"} className="ms-2 mb-1" size={"sm"} />
        )}
        <div className="float-end">
          {item.tags &&
            item.tags.map((tag, index) => (
              <AssetTag
                key={index}
                tagName={tag}
                className="me-2 mb-1"
                size={"sm"}
              />
            ))}
        </div>
      </h5>
      <div className="mb-3">
        <Form.Text>
          {SensolusDatetimeReact.parse(item.publishDate, "server").format(
            "DD MMMM yyyy"
          )}
        </Form.Text>
      </div>

      <SntMarkdown text={content} className={contentClass} />

      <hr />
    </div>
  );
};
